import { apiEspecialidadCreateRegistro, apiEspecialidadGetResgistros } from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import { getFormEspecialidad, getModelEspecialidad } from "../models/EspecialidadModel";

import { EnumEspecialidadPrincipal } from "../settings/enumConfig";
import { FormatColorReset } from "@material-ui/icons";
import { fnHandleChangeText } from "../settings/handleConfig";
import { useCatalogo } from "./CatalogoContext";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const EspecialidadContext = createContext();

export function EspecialidadProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, Post } = useRequest();
    const { entCatalogos } = useCatalogo();

    const [listaEspecialidades, setListaEspecialidades] = useState([]);
    const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState(getModelEspecialidad());
    const [modalOpenFormEspecialidad, setModalOpenFormEspecialidad] = useState(false);
    const [modalOpenEliminarEspecialidad, setModalOpenEliminarEspecialidad] = useState(false);
    const [formEspecialidad, setFormEspecialidad] = useState(getFormEspecialidad());

    const handleOpenFormEspecialidad = (value) => {
        setModalOpenFormEspecialidad(value);
    };

    const handleOpenEliminarEspecialidad = (value) => {
        setModalOpenEliminarEspecialidad(value);
    };

    const handleChangeEspecialidadSeleccionada = (value) => {
        setEspecialidadSeleccionada(value);
    };

    const handleChangeFormEspecialidad = fnHandleChangeText(formEspecialidad, setFormEspecialidad);

    const handleClickNuevaEspecialidad = () => {
        const especialidad = getModelEspecialidad();
        setEspecialidadSeleccionada(especialidad);
        fnFillFormEspecialidad(especialidad);
        setModalOpenFormEspecialidad(true);
    };

    const handleClickEditarEspecialidad = () => {
        if (especialidadSeleccionada.iIdEspecialidad === 0) {
            handleOpenAlert("Seleccione una especialidad para editar");
            return;
        }
        fnFillFormEspecialidad(especialidadSeleccionada);
        setModalOpenFormEspecialidad(true);
    };

    const handleClickEliminarEspecialidad = () => {
        if (especialidadSeleccionada.iIdEspecialidad === 0) {
            handleOpenAlert("Seleccione una especialidad para eliminar");
            return;
        }
        var bEliminar = true;
        entCatalogos.catEspecialidadBloqueados.map((especialidad) => {
            if (especialidad.fiId == especialidadSeleccionada.iIdEspecialidad) {
                bEliminar = false;
            }
        });
        // console.log(bEliminar);
        if (!bEliminar) {
            handleOpenAlert("Esta especialidad no se puede eliminar", "info");
            return;
        }

        setModalOpenEliminarEspecialidad(true);
    };

    const handleClickRefrescarDatos = () => {
        fnObtenerEspecialidades();
    };

    const handleSubmitFormEspecialidad = (e) => {
        fnPrevent(e);

        const { txtNombreEspecialidad } = formEspecialidad;
        const form = {
            ...formEspecialidad,
            txtNombreEspecialidad: {
                ...txtNombreEspecialidad,
                error: txtNombreEspecialidad.value === "",
            },
        };

        setFormEspecialidad(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entEspecialidad = {
            iIdEspecialidad: especialidadSeleccionada.iIdEspecialidad,
            sNombre: txtNombreEspecialidad.value,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            bActivo: true,
            bBaja: false,
        };

        fnGuardarEspecialidad(entEspecialidad);
    };

    const handleSubmitEliminarEspecialidad = () => {
        const entEspecialidad = {
            iIdEspecialidad: especialidadSeleccionada.iIdEspecialidad,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            bActivo: false,
            bBaja: true,
        };
        fnEliminarEspecialdad(entEspecialidad);
    };

    const fnFillFormEspecialidad = (especialidad) => {
        const { txtNombreEspecialidad } = getFormEspecialidad();
        setFormEspecialidad({
            ...formEspecialidad,
            txtNombreEspecialidad: {
                ...txtNombreEspecialidad,
                value: !especialidad.sNombre ? "" : especialidad.sNombre,
            },
        });
    };

    const fnObtenerEspecialidades = async (piIdEspecialidad = null) => {
        const payload = {
            loader: "Consultando especialidades...",
            url: apiEspecialidadGetResgistros + "?piIdEspecialidad=" + piIdEspecialidad,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaEspecialidades(response.Result.filter((x) => !x.bInterno));
        }
    };

    const fnGuardarEspecialidad = async (entEspecialidad) => {
        const payload = {
            loader: "Guardando especialidad...",
            url: apiEspecialidadCreateRegistro,
            body: entEspecialidad,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormEspecialidad(false);
            setEspecialidadSeleccionada(entEspecialidad);
            await fnObtenerEspecialidades();
        }
        fnPreventBlur();
    };

    const fnEliminarEspecialdad = async (entEspecialidad) => {
        const payload = {
            loader: "Eliminando especialidad...",
            url: apiEspecialidadCreateRegistro,
            body: entEspecialidad,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarEspecialidad(false);
            setEspecialidadSeleccionada(getModelEspecialidad());
            await fnObtenerEspecialidades();
        }
        fnPreventBlur();
    };

    return (
        <EspecialidadContext.Provider
            value={{
                listaEspecialidades,
                especialidadSeleccionada,
                modalOpenFormEspecialidad,
                modalOpenEliminarEspecialidad,
                formEspecialidad,
                handleOpenFormEspecialidad,
                handleOpenEliminarEspecialidad,
                handleChangeEspecialidadSeleccionada,
                handleChangeFormEspecialidad,
                handleClickNuevaEspecialidad,
                handleClickEditarEspecialidad,
                handleClickEliminarEspecialidad,
                handleClickRefrescarDatos,
                handleSubmitFormEspecialidad,
                handleSubmitEliminarEspecialidad,
            }}
        >
            {props.children}
        </EspecialidadContext.Provider>
    );
}

export function useEspecialidad() {
    return useContext(EspecialidadContext);
}
